import { Injectable } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';
import { Subject } from 'rxjs';
import { IFormStore } from '../interface';
import { BankStatementModel } from '../model';

type State = { state: 'idle' | 'invalid' } | { state: 'valid'; data: BankStatementModel };

const initialState: State = { state: 'idle' };

@Injectable()
export class BankStatementStore extends ComponentStore<State> implements IFormStore {
  readonly setStateInvalid = this.updater(() => ({ state: 'invalid' }));
  readonly setDataValid = this.updater<BankStatementModel>((_, data) => ({ state: 'valid', data: data }));
  readonly dataState$ = this.select(s => (s.state === 'valid' ? s : null));
  readonly submit$ = new Subject<void>();

  constructor() {
    super(initialState);
  }
}
